import "./TimeSelectorWidget.css";

const DEFAULT_TIME_RANGE_OPTIONS = ["Today", "Week", "Quarter", "Year", "All Time"];

function TimeSelectorWidget({
	value,
	onChange,
	options = DEFAULT_TIME_RANGE_OPTIONS,
	ariaLabel = "Dashboard time range",
}) {
	return (
		<div className="time-selector" role="tablist" aria-label={ariaLabel}>
			{options.map((option) => (
				<button
					key={option}
					type="button"
					className={`time-selector__button${value === option ? " is-active" : ""}`}
					onClick={() => onChange?.(option)}
					aria-pressed={value === option}
				>
					{option}
				</button>
			))}
		</div>
	);
}

export default TimeSelectorWidget;